export const threeDSecureConfigName = "threeDSecure";
